export type InvoiceTag =
  | "AWAITING_ISSUER_RESPONSE"
  | "AWAITING_REGISTRATION"
  | "BUG_REPORTED"
  | "WIP"
  | "AWAITING_INTERNAL_DECISION";

export const InvoiceValidationTags: InvoiceTag[] = [
  "AWAITING_ISSUER_RESPONSE",
  "AWAITING_REGISTRATION",
  "BUG_REPORTED",
];

export const InvoiceAssessmentTags: InvoiceTag[] = [
  "WIP",
  "AWAITING_INTERNAL_DECISION",
];

export type InvoiceTagModel = {
  tag: InvoiceTag;
  skynetUserId: string;
  invoiceTagId: string;
  invoiceId: string;
  createdAt: Date;
};
